import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { getData, getDataById } from "../../../utils/fetch";

import css from "./index.module.css";
import Table from "./components/Table";
import Header from "../../../components/Header";
import Button from "../../../components/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";



/**
 * Renders an table overview for a selected class, which student completed which mission/challenge 
 * and allows to reset progress
 * @param {String} classId 64 character uuid of given class
 */
const Progress = ({ classId, teacherId }) => {
  const [classes, setClasses] = useState(null);
  const [students, setStudents] = useState(null);
  const [missions, setMissions] = useState(null);
  const [challenges, setChallenges] = useState(null);
  const [selectedTask, setSelectedTask] = useState("Missionen");
  const [studentToMission, setStudentToMission] = useState(null);
  const [teacherToClasses, setTeacherToClasses] = useState(null);
  const [classToChallenges, setClassToChallenges] = useState(null);
  const [studentToChallenge, setStudentToChallenge] = useState(null);
  

  useEffect(() => {
    getData("/api/classes").then(data => setClasses(data));
    getData("/api/students").then(data => setStudents(data));
    getData("/api/missions").then(data => setMissions(data));
    getData("/api/challenges").then(data => setChallenges(data));
    getData("/api/studentToMission").then(data => setStudentToMission(data));
    getData("/api/studentToChallenge").then(data => setStudentToChallenge(data));
    getDataById("/api/classToChallenges/byId", {classId: classId}).then(data => setClassToChallenges(data));
    getDataById("/api/teacherToClasses/byId", {teacherId: teacherId}).then(data => setTeacherToClasses(data));
  },[classId, teacherId])

  return (
    <div className={css.page}>
      <Header isTeacher={true} nav="Lernfortschritt" />
      <div className={css.container}>
        <div className={css.progressContainer}>
          <div className={css.card}>
          <div className={css.buttons}>
            <Link to={classId === "null" ? `/teacher/${teacherId}` : `/teacher/${teacherId}/class/${classId}`}>
              {classId ? <Button>Klassenübersicht</Button> : <Button disabled>Klassenübersicht</Button>}
            </Link>
            <div className={css.selection}>
              <span className={selectedTask === "Missionen" ? css.selectedTask : ""} onClick={() => {setSelectedTask("Missionen")}}>Missionen</span>
              <span className={selectedTask === "Challenges" ? css.selectedTask : ""} onClick={() => {setSelectedTask("Challenges")}}>Challenges</span>
            </div>
          </div>
          <div className={css.classes}>
            {classes == null && <span>Loading...</span>}
            {classes != null && classes.length === 0 && (
              <span>No classes found</span>
            )}
            {classes?.filter(f => teacherToClasses?.find(ff => ff.class_id === f.id)).map((classItem) => (
                <div
                  key={classItem.id}
                  className={
                    classId === classItem.id
                      ? css.classItemSelected
                      : css.classItem
                  }
                >
                  {classItem.name}
                  <Link to={`/teacher/${teacherId}/progress/${classItem.id}`}>
                    <ArrowForwardIcon />
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </div>    
      <Table 
        students={students} 
        setStudents={setStudents} 
        challenges={challenges} 
        missions={missions} 
        classToChallenges={classToChallenges} 
        task={selectedTask} 
        classId={classId} 
        studentToChallenge={studentToChallenge} 
        studentToMission={studentToMission}
      />
      </div>
    </div>
  );
};

export default Progress;
